
const appRouters = [
  { path: '/app/homePage', component: () => import('@/views/App/homePage/index.vue') },
  { path: '/app/bannerDetail', component: () => import('@/views/App/banner/bannerDetail.vue') },
  { path: '/app/banner', component: () => import('@/views/App/banner/index.vue') },
  { path: '/app/recommend', component: () => import('@/views/App/recommend/index.vue') },
  { path: '/app/recommendDetail', component: () => import('@/views/App/recommend/recommendDetail.vue') },
  { path: '/app/upgradeVersion', component: () => import('@/views/App/upgradeVersion/index.vue') },
  { path: '/app/upgradeVersionDetail', component: () => import('@/views/App/upgradeVersion/detail.vue') },
  { path: '/app/productUpdate', component: () => import('@/views/App/productUpdate/index.vue') },
  { path: '/app/productUpdateDetail', component: () => import('@/views/App/productUpdate/detail.vue') },
  { path: '/app/service', component: () => import('@/views/Service/index.vue') }

]
export default appRouters
